import { Organisation, OrganisationsPage } from '~/services/organisations-api/types';
import { useMemo } from 'react';

export function useAlphabetisedOrganisations({
  orgs,
  active,
}: {
  orgs: OrganisationsPage | undefined;
  active: Organisation | undefined;
}) {
  const orgOptions = useMemo(() => {
    if (!orgs || orgs.totalCount === 0) {
      return [
        {
          label: active?.displayName || '',
          value: active?.id || '',
        },
      ];
    }

    return (
      orgs.organisations
        ?.map((org) => ({
          label: org.displayName,
          value: org.id,
        }))
        .sort((a, b) => a.label.localeCompare(b.label)) || []
    );
  }, [orgs, active]);

  return orgOptions;
}
